import React, { useState } from 'react'
import MuiAlert from '@material-ui/lab/Alert';
import { Button, Dialog, DialogContent, DialogTitle, Divider, makeStyles, Snackbar, Typography } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { editStatusNotaTransaksi, setMessageHutang } from '../../../config/redux/action/hutangAction';
import Cookies from 'js-cookie';
function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }
const DialogNotaAsli = ({HandleClickCloseDeleteDialog,tempID,...rest}) => {
    const useStyle = makeStyles((theme)=>({
        titleDialog:{
            width:'400px',
            [theme.breakpoints.down('sm')]:{
                width:'250px',
            },
            textAlign:'center',
        },
        contentDelete:{
            padding:'10px'
        },
        button:{
            display:'flex',
            justifyContent:'space-between',
            paddingBottom:"5px",
        },
        textFiled:{
            width:'100%',
            paddingBottom:"7px",
        },
    }));
    const classes=useStyle();
    const dispatch = useDispatch();
    const {data}=useSelector(state=>state.loginReducers);
    const [token,setToken] = useState(data.token);
    if(token ===''){
        setToken(Cookies.get('u_tkn'));
    }
    const {hutangMessage,isLoadingHutang}=useSelector(state=>state.hutangReducers);
    const [openSnackbar,setOpenSnackbar]=useState(false);
    const handleSubmit=()=>{
        const data={
            'idtransaksi':tempID,
            'notaasli':"Sudah Terima"
        }
        dispatch(editStatusNotaTransaksi(data,token,setOpenSnackbar,HandleClickCloseDeleteDialog));
    }
    const handleCloseSnackBar = (event, reason) => {
        if (reason === 'clickaway') {
            return;
          }
        setOpenSnackbar(false);
        setTimeout(()=>{
            dispatch(setMessageHutang(""));
        },100)
      };
    return (
        <div>
            <Dialog open={false} {...rest}>
            <DialogTitle className={classes.titleDialog}>Konfirmasi Penerimaan Nota Transaksi</DialogTitle>
                <Divider/>
                <DialogContent>
                    <div className={classes.contentDelete}>
                    <Typography align='center'>Apakah anda yakin sudah menerima nota transaksi</Typography>
                    <Typography align='center'>dari transaksi {tempID} ?</Typography>
                    </div>
                <div className={classes.button}>
                <Button 
                id='hapus'
                name='hapus'
                variant="contained" 
                color="primary" onClick={handleSubmit} 
                disabled={isLoadingHutang}>Ya</Button>
                <Button variant="contained" color="secondary" onClick={HandleClickCloseDeleteDialog}
                >Keluar</Button>
                </div>
                </DialogContent>
            </Dialog>
            <Snackbar open={openSnackbar} autoHideDuration={2000} onClose={handleCloseSnackBar}>
                <Alert 
                onClose={handleCloseSnackBar} 
                severity={hutangMessage === 'Status penerimaan nota asli berhasil di ubah' ? "success" : "error"} 
                onClick={HandleClickCloseDeleteDialog}>{hutangMessage}</Alert>
            </Snackbar>
        </div>
    )
}

export default DialogNotaAsli
